"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

var refPropType = function refPropType(props, propName, componentName) {
  if ((0, _typeof2.default)(props[propName]) === 'object' && props[propName].hasOwnProperty('current')) {
    return null;
  }

  return new Error(componentName + ": Invalid " + propName + " value. Expected an object created with React.createRef().");
};

var _default = (0, _createChainablePropType.default)(refPropType, 'ref object');

exports.default = _default;
module.exports = exports.default;